<script lang="ts">
	import type { ImageSizes } from "../../../core/schema/Image";

	export let images: ImageSizes[];

	let customClass = "";
	export { customClass as class };
</script>

<div class="max-w-[19.5rem] grow rounded-full bg-white px-3 py-[.7rem] {customClass}">
	<div class="glide__bullets flex h-0.5 bg-secondary-200" data-glide-el="controls[nav]">
		{#each images as _image, index}
			<span
				class="glide__bullet w-full cursor-pointer text-secondary transition-all duration-200 hover:bg-secondary-300"
				data-glide-dir="={index}"
			></span>
		{/each}
	</div>
</div>
